import { Box, SimpleGrid, Text } from '@mantine/core';
import type { IModem } from '../../../../../../shared/types/modem';
import { InfoField } from '../../../../../ui/infoField/InfoField';

export default function ModemBasicInfo(props: { data: IModem }) {
  const { data } = props;
  return (
    <div>
      <Text fw={600} mb="xs">
        모뎀 기본 정보
      </Text>
      <Box
        style={{
          borderTop: '1px solid var(--mantine-color-gray-3)',
          borderLeft: '1px solid var(--mantine-color-gray-3)',
        }}
      >
        <SimpleGrid cols={4} spacing={0} verticalSpacing={0}>
          <InfoField label="모뎀/라우터">{data.modem}</InfoField>
          <InfoField label="단말기 일련번호">{data.modemNo}</InfoField>
          <InfoField label="단말기 IMEI">{data.modemImei}</InfoField>
          <InfoField label="모뎀 상태">{data.statusYn === 'Y' ? '사용 중' : '회수'}</InfoField>
          <InfoField label="연결된 디바이스 정보">{data.mac}</InfoField>
          <InfoField label="비고">{data.memo}</InfoField>
        </SimpleGrid>
      </Box>
    </div>
  );
}
